import Vue from 'vue'
import VueMeta from 'vue-meta'


import './global-style.scss'


import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'nprogress/nprogress.css' // progress bar style

import './assets/css/bootstrap-rtl.css'
import './assets/css/BootstrapXL.css'
import './assets/css/fonts.css'

import 'babel-polyfill'

import App from './App'
import './registerServiceWorker'
import '@/utils/routing'
import router from './router'
import store from '@/store'
import { formatNumber } from "@/utils";
import {
  getToken,

} from '@/utils/auth'



import { BootstrapVue } from 'bootstrap-vue' // IconsPlugin
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
//Vue.use(Loading);
Vue.component('Loading', Loading);

Vue.mixin({
  methods: {
    log: console.log,
    formatNumber
  },
})

Vue.use(VueMeta)

// router.beforeEach((to, from, next) => {

//   document.title = to.meta.title || 'فست فود';
//   next();
// });

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const token = getToken();

  if (requiresAuth && !token) {
    sessionStorage.setItem('redirectPath', to.path);
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else if (requiresAuth && token) {
    next();
  } else {
    next();
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
